
import React, { useRef, useState } from "react";
import { FoundationsButton } from "../../GenericComponents/button";
import { PSFS_StatPortalProps } from "./Psfs_Slice";
declare let window: any
const UnicornApp = window.unicornInstance as any

const QualityCheck: React.FC<PSFS_StatPortalProps> = ({
    form,
    setForm,
    handleStepStatusAndSave,
    PSFSElements,
    stepManuallyChanged,
    handleStatusResetAndClose
}) => {
    const formRef = useRef<HTMLFormElement>(null);
    const [isCustomerSite] = useState<boolean>(UnicornApp.checkUserPrivileges("NTSPAdmin"))

    // Check if this step is already completed (form has moved past this step)
    const currentStepNo = PSFSElements?.PSFSStep?.find(step => step.ETLMatchValue === "QualityCheck")?.StepNo ?? 1;
    const completionStatuses = ["Quality Check Complete", "Clinically Canceled", "Veteran Declined Appt."];
    const completedStatusKeys = (PSFSElements?.PSFSStatus ?? [])
        .filter((status: any) => completionStatuses.includes(status.ETLMatchValue) || completionStatuses.includes(status.FriendlyName))
        .map((status: any) => status._key);
    const isStepCompleted = !stepManuallyChanged
        && form.fk_Step !== undefined
        && form.fk_Step !== -1
        && form.fk_Step >= currentStepNo
        && completedStatusKeys.includes(form.fk_Status);

    return (
        <>
            <form
                className="psfs-form-container"
                ref={formRef}
            >
                <div className="psfs-container mb-1">
                    <div className="first-child mb-4">
                        <label className="psfs-main-label" style={{height: '168px'}}>Connected to Appointment.</label>
                        <div className="form-group psfs-buttons mt-10">
                            {!isStepCompleted && (
                                <span>
                                    {PSFSElements?.PSFSStatus
                                        .filter((status: any) => status.FriendlyName === "Quality Check Complete")
                                        .map((status: any) => (
                                            <span key={status._key}>
                                                <FoundationsButton
                                                    id={status._key}
                                                    tabIndex={1}
                                                    disabled={!isCustomerSite}
                                                    buttonClasses="psfs-green-button"
                                                    onClick={() => handleStepStatusAndSave("QualityCheck", status._key)}
                                                >
                                                    {status.FriendlyName}
                                                </FoundationsButton>
                                            </span>
                                        ))}
                                </span>
                            )}
                            {!isStepCompleted && (
                                <>
                                    <span>
                                        {PSFSElements?.PSFSStatus
                                            .filter((status: any) => status.FriendlyName === "Veteran Declined Appt.")
                                            .map((status: any) => (
                                                <span key={status._key}>
                                                    <FoundationsButton
                                                        id={status._key}
                                                        tabIndex={3}
                                                        buttonClasses="psfs-red-button"
                                                        disabled={!isCustomerSite}
                                                        onClick={() => handleStatusResetAndClose("QualityCheck", status._key)}
                                                    >
                                                        {status.FriendlyName}
                                                    </FoundationsButton>
                                                </span>
                                            ))}

                                    </span>
                                    <span>
                                        {PSFSElements?.PSFSStatus
                                            .filter((status: any) => status.FriendlyName === "Clinically Canceled")
                                            .map((status: any) => (
                                                <span key={status._key}>
                                                    <FoundationsButton
                                                        id={status._key}
                                                        tabIndex={4}
                                                        buttonClasses="psfs-red-button"
                                                        disabled={!isCustomerSite}
                                                        onClick={() => handleStatusResetAndClose("QualityCheck", status._key)}
                                                    >
                                                        {status.FriendlyName}
                                                    </FoundationsButton>
                                                </span>
                                            ))}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default QualityCheck;